import Api from './api';

export const addItem = async (formData) => {
  let data = []
  await Api.post(`/whitelabel`, formData)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const editItem = async (formData) => {
  let data = []
  await Api.put(`/whitelabel`, formData)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const getSystemTheme = async () => {
  let data = []
  await Api.get(`/whitelabel/systemtheme`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}